export default [
  {
    path: '/cat4mro',
    name: 'cat4mro',
    redirect: { name: 'cat4mro.search' },
    component: {
      render(c) { return c('router-view'); },
    },
    meta: {
      breadcrumb: 'CAT4MRO',
      menuOptions: {
        title: 'CAT4MRO',
      },
    },
    children: [
      {
        path: 'search',
        name: 'cat4mro.search',
        props: route => ({
          query: route.query.q,
        }),
        component: () => import('@/pages/buyer/cat4mro/search'),
        meta: {
          breadcrumb: 'Search',
        },
      },
      {
        path: ':slug/information',
        name: 'cat4mro.supplier-information',
        component: () => import('@/pages/supplier/organization/public-profile'),
        meta: {
          breadcrumb: 'Supplier Profile',
        },
      },
      {
        path: '/shoppingcart',
        name: 'cat4mro.shoppingcart',
        component: () => import('@/pages/buyer/catalog/cart'),
        meta: {
          breadcrumb: 'Shopping Cart',
        },
      },
      {
        path: 'catalog/:catalog/search',
        name: 'cat4mro.catalog.search',
        props: route => ({
          catalog: route.params.catalog,
          query: route.query.q,
        }),
        component: () => import('@/pages/buyer/catalog/search'),
        meta: {
          breadcrumb() {
            const storeInfo = this.$store.getters['cat4mro/catalogInfo'];
            if (!storeInfo || !storeInfo.organization) {
              return 'Supplier Catalog';
            }

            return `Supplier Catalog ${storeInfo.organization.name}`;
          },
        },
      },
      {
        path: 'catalog/:catalog/product/:item',
        name: 'cat4mro.catalog.products.item',
        props: route => ({
          product: route.params.item,
          catalog: route.params.catalog,
          query: route.params.query,
        }),
        component: () => import('@/pages/buyer/catalog/product'),
        meta: {
          breadcrumb() {
            const storeInfo = this.$store.getters['catalog/currentProductItemInfo'];
            if (!storeInfo) {
              return 'Ítem';
            }

            return `Ítem - ${storeInfo.name}`;
          },
        },
      },
    ],
  },
  {
    path: '/request-information',
    name: 'request-information',
    redirect: { name: 'request-information.search' },
    component: {
      render(c) { return c('router-view'); },
    },
    meta: {
      breadcrumb: 'Request for Information',
      menuOptions: {
        title: 'Request for Information',
      },
    },
    children: [
      {
        path: 'search',
        name: 'request-information.search',
        component: () => import('@/pages/buyer/request_information/search'),
        meta: {
          breadcrumb: 'Search',
        },
      },
      {
        path: ':request/request',
        name: 'request-information.request',
        props: route => ({
          requestId: route.params.request,
        }),
        component: () => import('@/pages/buyer/request_information/request'),
        meta: {
          breadcrumb: 'Request for Information',
        },
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/routes/buyer.js